// extracted by mini-css-extract-plugin
export default {"cellContainer":"CellLogMessage_cellContainer__zUl7s","cellLink":"CellLogMessage_cellLink__1XCyL"};